// extracted by mini-css-extract-plugin
export default {"list":"Menu_list__F1d0w","active":"Menu_active__Erzdq"};